export function ErrorMessage({message = ''}) {
  return (
    <div className="col-span-full">
      <span className="text-red-600 text-[10px] relative top-[1px] block">{message}</span>
    </div>
  );
}
